import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faToggleOn } from "@fortawesome/pro-solid-svg-icons";
import { faToggleOff } from "@fortawesome/pro-light-svg-icons";

const ApplyToAllStatusToggle = ({
  title,
  className,
  values,
  setValues,
  fieldName,
  isEdit,
  isSave,
  disableYos = false,
  hoursFieldName,
  hoursListFieldName,
}) => {
  const onToggleChange = (value) => {
    let hours = !value ? values[hoursFieldName] : null;
    let hoursList = value
      ? values[hoursListFieldName]
      : values[hoursListFieldName]?.map((item) => ({
          ...item,
          hoursOfService: null,
        }));
    setValues({
      ...values,
      [hoursFieldName]: hours,
      [hoursListFieldName]: hoursList,
      [fieldName]: !values[fieldName],
    });
  };

  return (
    <div
      className={`d-flex flex-row align-items-center ${
        values[fieldName] ? "" : "justify-content-between"
      }`}
    >
      <div className={`d-flex ${className}`}>{title}</div>
      <div className="d-flex ml-1 align-items-center apply-to-all-status">
        <div>(Apply same hours to all employment statuses</div>
        <FontAwesomeIcon
          className={`toggleIcon ${
            (isEdit && !isSave) || disableYos ? "disabled " : ""
          } ${values[fieldName] ? "primary-small" : "grey-shade"}`}
          onClick={() => {
            !((isEdit && !isSave) || disableYos) &&
              onToggleChange(values[fieldName]);
          }}
          // style={{
          //   color: values[fieldName] ? "$primary" : "#BCBCC0",
          // }}
          icon={values[fieldName] ? faToggleOn : faToggleOff}
          size="2x"
        />
        <div style={{ marginLeft: "2px" }}>)</div>
      </div>
    </div>
  );
};

export default ApplyToAllStatusToggle;
